/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Validation_Name_RequiredInputs */

const en_profile_validation_name_required = /** @type {(inputs: Profile_Validation_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a display name.`)
};

const pt_br2_profile_validation_name_required = /** @type {(inputs: Profile_Validation_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um nome de exibição.`)
};

/**
* | output |
* | --- |
* | "Enter a display name." |
*
* @param {Profile_Validation_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_validation_name_required = /** @type {((inputs?: Profile_Validation_Name_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Validation_Name_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_validation_name_required(inputs)
	return pt_br2_profile_validation_name_required(inputs)
});